"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var Router = function Router(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/applications/networking/router-router" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    id: "simplified_icons-technical-router-router" + unique,
    xlinkHref: "#path-1-router" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-router" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M11.5,8.41464715 C10.9174038,8.20872894 10.5,7.65310941 10.5,7 C10.5,6.17157288 11.1715729,5.5 12,5.5 C12.8284271,5.5 13.5,6.17157288 13.5,7 C13.5,7.65310941 13.0825962,8.20872894 12.5,8.41464715 L12.5,13 L20.1,13 C20.5970563,13 21,13.4029437 21,13.9 L21,17.4 C21,17.8970563 20.5970563,18.3 20.1,18.3 L19.2,18.3 L19.2,20.1 C19.2,20.5970563 18.7970563,21 18.3,21 L17.4,21 C16.9029437,21 16.5,20.5970563 16.5,20.1 L16.5,18.3 L7.5,18.3 L7.5,20.1 C7.5,20.5970563 7.09705627,21 6.6,21 L5.7,21 C5.20294373,21 4.8,20.5970563 4.8,20.1 L4.8,18.3 L3.9,18.3 C3.40294373,18.3 3,17.8970563 3,17.4 L3,13.9 C3,13.4029437 3.40294373,13 3.9,13 L11.5,13 L11.5,8.41464715 Z M14,9.23610651 C14.6137494,8.68678595 15,7.88849981 15,7 C15,5.34314575 13.6568542,4 12,4 C10.3431458,4 9,5.34314575 9,7 C9,7.88849981 9.38625064,8.68678595 10,9.23610651 L10,10.4648712 C8.80439726,9.77325238 8,8.48056471 8,7 C8,4.790861 9.790861,3 12,3 C14.209139,3 16,4.790861 16,7 C16,8.48056471 15.1956027,9.77325238 14,10.4648712 L14,9.23610651 Z",
    fill: "inherit",
    id: "path-1-router" + unique
  }))));
};

Router.propTypes = propTypes;
var _default = Router;
exports["default"] = _default;